module.exports = __webpack_public_path__ + "static/media/14UNEP5.fc9588a5.jpg";